import { useLingui } from "@lingui/react";
import { formatMileage, type MileageUnit } from "@mobility-item-page/utilities";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";

export const Mileage = ({ distance, unit }: { distance?: number; unit?: MileageUnit }) => {
  const { locale } = useAppConfig();
  const { i18n } = useLingui();
  if (distance == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.distance.mileage",
    message: "Mileage",
    comment: "Label for mileage in ad section summary",
  });

  return <FieldValuePair field={field} value={formatMileage(distance, unit, locale)} />;
};
